var $ = require('jquery');
require('select2');

var self = {};

self.initialise = function() {
  function BindSelects() {
    $('.enquiry-form select').select2({
      width: '100%',
      minimumResultsForSearch: -1,
    });

    $('.FormPanel select').select2({
      width: '100%',
      minimumResultsForSearch: -1,
    });

    $('.contact-page select').select2({
      width: '352px',
      minimumResultsForSearch: -1,
    });
  }

  BindSelects();

  var postbackHandlerTries = 10;

  function BindPostbackHandler() {
    if (postbackHandlerTries > 0) {
      try {
        var pageRequestManager = Sys.WebForms.PageRequestManager.getInstance();
        pageRequestManager.add_endRequest(BindSelects);
      } catch (e) {
        console.log('failed to bind postback select2');
        postbackHandlerTries--;
        setTimeout(BindPostbackHandler, 50); // in 50ms try again
      }
    }
  }

  BindPostbackHandler();
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/call-select2.js